import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Card, Stack, Text, ThemeIcon, UnstyledButton } from "@mantine/core";
import type { LucideIcon } from "lucide-react";

export interface AreaTileProps {
  to: string;
  icon: LucideIcon;
  title: string;
  /** One line under the title (dimmed). */
  description?: ReactNode;
  /** A small status under the description, e.g. a Badge ("Connected"). */
  status?: ReactNode;
}

/**
 * One area on a landing grid — an Office Guide category, a Settings area: a
 * centred icon, the title and a line of detail, the whole card a link to the
 * area's own page. Lay them out in `<SimpleGrid cols={{ base: 2, sm: 3 }}>`.
 */
export function AreaTile({ to, icon: Icon, title, description, status }: AreaTileProps) {
  return (
    <UnstyledButton component={Link} to={to} h="100%" style={{ borderRadius: "var(--mantine-radius-md)" }}>
      <Card withBorder padding="lg" radius="md" h="100%">
        <Stack gap="xs" align="center" ta="center">
          <ThemeIcon variant="light" size={48} radius="md">
            <Icon size={26} />
          </ThemeIcon>
          <Text fw={600}>{title}</Text>
          {description && (
            <Text fz="sm" c="dimmed">
              {description}
            </Text>
          )}
          {status}
        </Stack>
      </Card>
    </UnstyledButton>
  );
}
